import LegalPage from "@/components/LegalPage";

export default function Terms() {
  return (
    <LegalPage title="Terms & Conditions." updated="Feb 2026" testId="terms-page">
      <p>Welcome to Carpe Diem Goa. By accessing our website (<a href="https://carpediemgoa.com">carpediemgoa.com</a>) or booking any of our workshops, classes, exhibitions or events, you agree to be bound by the following terms.</p>

      <h2>1. About us</h2>
      <p>Carpe Diem is an art gallery, art centre, ceramic studio, cafe, stage and co-working space located at H. No. 81/2, Godinho House, Gomes Waddo, Majorda, South Goa 403713, India. Contact: <a href="mailto:info@carpediemgoa.com">info@carpediemgoa.com</a> · +91 98225 80152.</p>

      <h2>2. Bookings & event registration</h2>
      <ul>
        <li>All bookings are subject to availability and are confirmed only after successful payment.</li>
        <li>A booking is complete when you receive an email confirmation with a booking ID.</li>
        <li>Ticket-holders must present the booking ID (email or screenshot) on arrival.</li>
        <li>Bookings are personal and non-transferable without our written consent.</li>
      </ul>

      <h2>3. Pricing</h2>
      <p>All prices are displayed in Indian Rupees (₹) and are inclusive of applicable taxes unless stated otherwise. We reserve the right to change pricing at any time; changes do not affect bookings already confirmed.</p>

      <h2>4. Conduct on premises</h2>
      <p>We welcome all guests to enjoy the space respectfully. Carpe Diem reserves the right to refuse entry or ask any person to leave if their conduct is disruptive, unsafe, or in breach of Indian law. No refunds are issued in such cases.</p>

      <h2>5. Photography</h2>
      <p>We may photograph events for marketing on our website and social media. If you would prefer not to appear in photographs, please let a staff member know at the start of the event.</p>

      <h2>6. Liability</h2>
      <p>Participation in workshops, classes and studio use is at your own risk. Carpe Diem accepts no liability for loss, injury or damage to personal property beyond that required by Indian consumer law. Children under 12 must be accompanied by a responsible adult at all times.</p>

      <h2>7. Intellectual property</h2>
      <p>All content on carpediemgoa.com — logo, text, images, artist portfolios — is the property of Carpe Diem or its respective artists and may not be reproduced without written permission.</p>

      <h2>8. Governing law</h2>
      <p>These terms are governed by the laws of India. Any dispute arising will be subject to the exclusive jurisdiction of the courts at Margao, South Goa.</p>

      <h2>9. Changes</h2>
      <p>We may update these terms from time to time. The "Last updated" date at the top of this page reflects the most recent revision.</p>
    </LegalPage>
  );
}
